import { useLanguage } from './language-context';
import { useTheme } from './theme-context';

// The light/dark switch (CB-16) — the merchant design's top-bar control (M:192-200):
// one button with a sun thumb and a moon thumb, the showing theme's thumb raised.
// Pressing it pins the opposite of what is showing (the Account page's Language &
// theme card does the same); until then the device decides.
// `menuItem` when it sits inside the account menu (a menu may only own menu items).
export function ThemeToggle({ menuItem = false }: { menuItem?: boolean } = {}) {
  const { t } = useLanguage();
  const { resolved, setPref } = useTheme();
  const dark = resolved === 'dark';
  return (
    <button
      type="button"
      className="theme-toggle"
      role={menuItem ? 'menuitem' : undefined}
      onClick={() => setPref(dark ? 'light' : 'dark')}
      aria-label={t(dark ? 'theme.switch_to_light' : 'theme.switch_to_dark')}
      title={t(dark ? 'theme.current_dark' : 'theme.current_light')}
      data-resolved={resolved}
    >
      <span className={dark ? 'theme-toggle__thumb' : 'theme-toggle__thumb is-on'} aria-hidden="true">
        <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
          <path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 1 0-8" />
          <path d="M12 2v2" />
          <path d="M12 20v2" />
          <path d="M2 12h2" />
          <path d="M20 12h2" />
          <path d="m5 5 1.5 1.5" />
          <path d="M17.5 17.5 19 19" />
          <path d="M19 5l-1.5 1.5" />
          <path d="M6.5 17.5 5 19" />
        </svg>
      </span>
      <span className={dark ? 'theme-toggle__thumb is-on' : 'theme-toggle__thumb'} aria-hidden="true">
        <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
          <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4 8.5 8.5 0 1 0 20 14.5" />
        </svg>
      </span>
    </button>
  );
}
